import { createStore } from "vuex";
import { getProfile } from "@/services/clientAuthApi";

export default createStore({
  state: {
    users: [],
    user: null,
    tokenLimit: 25000,
  },
  getters: {
    getUserId(state) {
      if (!state.user) {
        return null;
      }
      return state.user.uuid;
    },
    getUserDisplayName(state) {
      if (!state.user) {
        return null;
      }

      if (!state.user.first_name && !state.user.last_name) {
        return state.user.username;
      }

      return state.user.first_name + " " + state.user.last_name;
    },
    getUserOrganization(state) {
      if (!state.user) {
        return null;
      }
      return state.user.organization;
    },
    isUserAdmin(state) {
      if (!state.user) {
        return false;
      }

      const userId = state.user.uuid;
      const organizationAuthorId = state.user.organization.author_id;

      return userId === organizationAuthorId;
    },
  },
  mutations: {
    setProperty(state, { key, value }) {
      state[key] = value;
    },
    setUser(state, user) {
      state.user = user;
    },
    updateUserOrganizationProperty(state, { key, value }) {
      if (!state.user.organization) {
        state.user.organization = {};
      }
      state.user.organization[key] = value;
    },
    updateUserProperty(state, { key, value }) {
      state.user[key] = value;
    },
  },
  actions: {
    async fetchProfile({ commit }) {
      const { isError, responseData } = await getProfile();
      if (isError || !responseData?._success) return;
      const client = responseData.client;
      commit("setUser", {
        uuid: String(client.id),
        username: client.email,
        first_name: client.first_name || "",
        last_name: client.last_name || "",
        email: client.email,
        phone: client.phone || "",
        photo: client.photo || null,
      });
    },
  },
});
